export default {

    // SET COURSES STORE GENERAL
    /*obtengo todos los cursos*/
    SET_COURSES: function(state, courses) {
        state.courses = courses;
    },

    SET_ALL_COURSES: function(state, courses) {
        state.all_courses = courses
    },
    
    SET_SELECTED_COURSE: function (state, course){
        state.selected_course = course
    },
    /*obtengo tipo de recurso*/

    resource_type: function(state, resource_type) {
        state.resource_type = resource_type;
    },

    SET_KEY(state, key) {
        state.key = key
    },

    SET_LOADER: function(state, loader) {
        state.loading = loader;
    },

    /*obtengo el companyId del usuario*/
    coureseId: function(state, coureseId) {
        state.coureseId = coureseId;
    },

    /*obtengo todos los grupos de examenes de la company*/
    name: function(state, name) {
        state.name = name
    },

    /*branding in top navigation*/
    description: function(state, description) {
        state.description = description
    },

    /*ID de los videos en vimeo*/
    vimeo_Id: function(state, vimeo_Id) {
        state.vimeo_Id = vimeo_Id
    },

    /*all resource in lesson*/
    resources: function(state, resources) {
        state.resources = resources
    },

    /*ID lesson*/
    lesson_Id: function(state, lesson_Id) {
        state.lesson_Id = lesson_Id
    },

    /*total progress user_lessons*/
    total_progress: function(state, total_progress) {
        state.total_progress = total_progress
    },


    resource_id: function(state, resource_id) {
        state.resource_id = resource_id
    },

    allModules: function(state, allModules) {
        state.allModules = allModules
    },

    allLesson: function(state, allLesson) {
        state.allLesson = allLesson
    },


    allResources: function(state, allResources) {
        state.allResources = allResources
    },
    video_finish: function(state, video_finish) {
        state.video_finish = video_finish
    },
    module_selected: function(state, module_selected) {
        state.module_selected = module_selected
    },
};